import './App.css';
import Weather from "./Weather";

function App() {
  return (
    <div className="App">
        <h1>
          
        </h1>
        <Weather city="Madrid" />
        <a href="https://github.com/lynchycat21/weather-react-app">Open source code</a> by Cathy Lynch.
    </div>
  );
}

export default App;
